export default __webpack_public_path__ + "static/media/expand.486a5fc4.svg";